export default __webpack_public_path__ + "static/media/icon.knee pads.5ca37c1c.svg";